import React, { useState, useEffect } from "react";
import { Grid, Typography, Paper, CircularProgress } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { useTranslation } from "react-i18next";
import CustomButton from "../../components/CustomButton";
import { ReactComponent as FailureIcon } from "../../assets/signup/failure.svg";
import { windowHeight, windowWidth } from "../../utils/utils";
import { backendClient } from "../../api/backend";
import { tracker } from "../../analytics";

const PaymentCancelScreen = () => {
    const theme = useTheme();
    const { t } = useTranslation();
    const isDark = theme.palette.mode === "dark";
    const [retrying, setRetrying] = useState(false);
    const [retryError, setRetryError] = useState(null);

    const pendingCheckoutRaw = localStorage.getItem('pendingCheckout');
    const pendingCheckout = pendingCheckoutRaw ? JSON.parse(pendingCheckoutRaw) : null;

    useEffect(() => {
        tracker.conversion({ category: 'checkout_abandoned', action: 'cancel', properties: pendingCheckout ? { plan: pendingCheckout.plan, billing_cycle: pendingCheckout.billing, region: pendingCheckout.region } : {} })
    }, []) // eslint-disable-line

    const handleRetryCheckout = async () => {
        const checkout = pendingCheckout || { plan: 'starter', billing: 'monthly', region: 'default' };
        setRetrying(true);
        setRetryError(null);
        try {
            const sessionData = await backendClient.createStripeSession(
                checkout.plan,
                checkout.billing,
                null,
                checkout.region,
                checkout.lang || 'auto',
                checkout.quantity || 1,
                checkout.currency || null
            );
            window.location.href = sessionData.session_url;
        } catch (err) {
            setRetryError(err.message || t("payment_retry_error"));
            setRetrying(false);
        }
    };

    return (
        <Grid
            container
            sx={{
                height: "90vh",
                justifyContent: "center",
                alignItems: "center",
                backgroundColor: theme.palette.background.default,
            }}
        >
            <Paper
                elevation={isDark ? 0 : 4}
                sx={{
                    borderRadius: "20px",
                    width: "60%",
                    padding: "40px",
                    textAlign: "center",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "center",
                    height: "60vh",
                    backgroundColor: theme.palette.background.paper,
                    border: isDark ? `1px solid ${theme.palette.divider}` : "none",
                }}
            >
                <FailureIcon
                    style={{
                        width: windowHeight / 2.5,
                        height: windowHeight / 2.5,
                        marginRight: windowWidth / 40,
                        marginBottom: "20px",
                    }}
                />

                <Typography variant="h4" sx={{ mb: 2, color: theme.palette.text.primary }}>
                    {t("payment_abandoned_title")}
                </Typography>

                <Typography variant="body1" sx={{ mb: 4, color: theme.palette.text.secondary }}>
                    {t("payment_abandoned_message")}
                </Typography>

                {retryError && (
                    <Typography variant="body2" sx={{ mb: 2, color: theme.palette.error.main }}>
                        {retryError}
                    </Typography>
                )}

                <CustomButton
                    text={retrying ? <CircularProgress size={20} color="inherit" /> : t("payment_retry_checkout")}
                    outlined={false}
                    onClick={handleRetryCheckout}
                    disabled={retrying}
                    sx={{ width: "50%", padding: "10px 0" }}
                />
            </Paper>
        </Grid>
    );
};

export default PaymentCancelScreen;
